import { render, staticRenderFns } from "./addmb.vue?vue&type=template&id=4f7e1bee&scoped=true&"
import script from "./addmb.vue?vue&type=script&lang=js&"
export * from "./addmb.vue?vue&type=script&lang=js&"
import style0 from "./addmb.vue?vue&type=style&index=0&id=4f7e1bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e1bee",
  null
  
)

export default component.exports